import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MapPinIcon, ClockIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-schwarz text-gray-light py-20 border-t border-gray-800" data-id="element-56">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-57">
        {/* Brand */}
        <div data-id="element-58">
          <Link to="/" className="mb-8 block" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/5ai4To1omyuTFdS9ff8Uei/sekundarlogo.png" alt="edel & weiss Logo" className="h-12 w-auto object-contain" data-id="element-60" />
          </Link>
          <p className="text-gray-medium text-sm font-lora leading-relaxed mb-6" data-id="element-61">
            Ihre Praxis für ganzheitliche Zahnmedizin im Herzen der Stadt
            Nürnberg. Spezialisiert, interdisziplinär und zukunftsweisend.
          </p>
        </div>

        {/* Quick Links */}
        <div data-id="element-62">
          <h4 className="text-weiss font-poppins font-bold text-lg mb-6 uppercase tracking-widest" data-id="element-63">
            Navigation
          </h4>
          <ul className="space-y-3 text-sm font-lora" data-id="element-64">
            <li data-id="element-65">
              <Link to="/leistungen" className="hover:text-gold transition-colors" data-id="element-66">
                Leistungen
              </Link>
            </li>
            <li data-id="element-67">
              <Link to="/kieferorthopaedie" className="hover:text-gold transition-colors" data-id="element-68">
                Kieferorthopädie
              </Link>
            </li>
            <li data-id="element-69">
              <Link to="/oralchirurgie" className="hover:text-gold transition-colors" data-id="element-70">
                Oralchirurgie
              </Link>
            </li>
            <li data-id="element-71">
              <Link to="/team" className="hover:text-gold transition-colors" data-id="element-72">
                Team
              </Link>
            </li>
            <li data-id="element-73">
              <Link to="/karriere" className="hover:text-gold transition-colors" data-id="element-74">
                Karriere
              </Link>
            </li>
            <li data-id="element-75">
              <Link to="/blog" className="hover:text-gold transition-colors" data-id="element-76">
                Blog
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div data-id="element-77">
          <h4 className="text-weiss font-poppins font-bold text-lg mb-6 uppercase tracking-widest" data-id="element-78">
            Kontakt
          </h4>
          <ul className="space-y-4 text-sm font-lora" data-id="element-79">
            <li className="flex items-start space-x-3" data-id="element-80">
              <MapPinIcon className="w-5 h-5 text-gold shrink-0" data-id="element-81" />
              <span data-id="element-82">
                Musterstraße 123
                <br data-id="element-83" />
                90402 Nürnberg
              </span>
            </li>
            <li className="flex items-center space-x-3" data-id="element-84">
              <PhoneIcon className="w-5 h-5 text-gold shrink-0" data-id="element-85" />
              <a href="tel:091156836360" className="hover:text-weiss transition-colors" data-id="element-86">
                0911-56 83 63 60
              </a>
            </li>
            <li className="flex items-center space-x-3" data-id="element-87">
              <MailIcon className="w-5 h-5 text-gold shrink-0" data-id="element-88" />
              <a href="mailto:info@edel-und-weiss.de" className="hover:text-weiss transition-colors" data-id="element-89">
                info@edel-und-weiss.de
              </a>
            </li>
          </ul>
        </div>

        {/* Hours */}
        <div data-id="element-90">
          <h4 className="text-weiss font-poppins font-bold text-lg mb-6 uppercase tracking-widest" data-id="element-91">
            Öffnungszeiten
          </h4>
          <ul className="space-y-3 text-sm font-lora" data-id="element-92">
            <li className="flex justify-between" data-id="element-93">
              <span data-id="element-94">Mo - Do</span>
              <span data-id="element-95">08:00 - 20:00</span>
            </li>
            <li className="flex justify-between" data-id="element-96">
              <span data-id="element-97">Freitag</span>
              <span data-id="element-98">08:00 - 20:00</span>
            </li>
            <li className="flex justify-between text-gold font-bold" data-id="element-99">
              <span data-id="element-100">Samstag</span>
              <span data-id="element-101">08:00 - 14:00</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-xs font-poppins text-gray-medium" data-id="element-102">
        <p data-id="element-103">
          &copy; {new Date().getFullYear()} edel & weiss Zahnarztpraxis
          Nürnberg. Alle Rechte vorbehalten.
        </p>
        <div className="flex space-x-6 mt-4 md:mt-0 uppercase tracking-widest" data-id="element-104">
          <Link to="/impressum" className="hover:text-weiss transition-colors" data-id="element-105">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-weiss transition-colors" data-id="element-106">
            Datenschutz
          </Link>
        </div>
      </div>
    </footer>;
}